/** Початкові правила (еквівалент колишнього `utils/normalizeProductName.js`). */
export const DEFAULT_PRODUCT_NAME_NORMALIZE_CONFIG = {
    trimAfterDash: true,
    stripTrailingYear: true,
    rules: [
        { kind: "includes", pattern: "комплект білизни", result: "Комплект білизни" },
        { kind: "exactList", patterns: ["футболка двонитка"], result: "Футболка" },
        {
            kind: "exactList",
            patterns: [
                "лонгслів amour toujours",
                "лонгслів gluten morgen",
                "лонгслів chatting&drinking",
                "лонгслів «love is…»",
                "лонгслів «work is my boyfriend»",
                "лонгслів «i love hlib»",
                "лонгслів «for my princess»",
            ],
            result: "Лонгслів з друком",
        },
        {
            kind: "exactList",
            patterns: [
                "футболка gluten morgen",
                "футболка bla bla bla",
                "футболка chatting&drinking",
                "футболка quiet place",
                "футболка starter pack",
                "футболка mom club",
                "футболка kiss me",
                "футболка amour toujours",
                "футболка childhood",
                "футболка woman pack",
                "футболка amaze me",
                "футболка «home alone»",
                "футболка «i told chat gpt»",
                "футболка «new year starter pack»",
                "футболка «i love hlib»",
                "футболка «helga&arnold»",
                "футболка «for my princess»",
                "kiss me harder",
                "футболка «i miss you? no»",
                "футболка «i told chatgpt about u»",
                "футболка «love is…»",
                "футболка  «love is…»",
                "футболка «hot girls go to the therapy»",
                "футболка «be good or i will text santa»",
            ],
            result: "Футболка з друком",
        },
        {
            kind: "exactList",
            patterns: [
                "футболка чоловіча «home alone»",
                "футболка чоловіча «i told chat gpt»",
                "футболка чоловіча «brain is sexier than abs»",
                "футболка чоловіча «work is my girlfriend»",
                "футболка чоловіча «i told chatgpt about u»",
                "футболка чоловіча «hot boys go to the therapy»",
                "футболка чоловіча «i miss you? no.»",
                "футболка чоловіча «be good or i will text santa»",
            ],
            result: "Футболка чоловіча з друком",
        },
        {
            kind: "exactList",
            patterns: ["футболка mom says", "футболка mother", "футболка fantasies", "футболка fall in love"],
            result: "Футболка з вишивкою",
        },
        { kind: "includes", pattern: "зіпхуді петля", result: "Зіпхуді петля" },
        { kind: "exactList", patterns: ["флісові джогери"], result: "Джогери до фліски" },
        { kind: "exactList", patterns: ["піжама новорічна", "піжама з мереживом"], result: "Піжама з мереживом" },
        {
            kind: "exactList",
            patterns: [
                "світшот «new year starter pack»",
                "світшот «home alone»",
                "світшот «i love hlib»",
                "світшот «for my princess»",
                "світшот «work is my boyfriend»",
                "світшот чоловічий «work is my girlfriend»",
            ],
            result: "Світшот з друком",
        },
        {
            kind: "exactList",
            patterns: ["худі чоловічий «brain is sexier than abs»"],
            result: "Худі з друком",
        },
        { kind: "includes", pattern: "боді", result: "Боді" },
        { kind: "includes", pattern: "піжама зі штанами", result: "Піжама з штанами" },
        { kind: "includes", pattern: "спідниця з паєтками", result: "Спідниця-шорти з паєтками" },
        { kind: "exactList", patterns: ["поло"], result: "Футболка поло" },
        {
            kind: "any",
            clauses: [
                { kind: "includes", pattern: "джогери петля" },
                { kind: "includes", pattern: "джогери чоловічі" },
            ],
            result: "Джогери петля",
        },
        {
            kind: "any",
            clauses: [
                { kind: "includes", pattern: "шорти льон" },
                { kind: "includes", pattern: "шорти короткі" },
            ],
            result: "Шорти короткі",
        },
        { kind: "includes", pattern: "худі петля", result: "Худі петля" },
        { kind: "includes", pattern: "світшот петля", result: "Світшот петля" },
        {
            kind: "any",
            clauses: [
                { kind: "includes", pattern: "палаццо зі шлейками" },
                { kind: "exact", value: "палаццо з поясом" },
                { kind: "exact", value: "палаццо костюмні" },
            ],
            result: "Палаццо",
        },
        { kind: "includes", pattern: "гольф", result: "Гольф" },
        { kind: "includes", pattern: "корсет джинсовий", result: "Корсет" },
        { kind: "includes", pattern: "купальник", result: "Купальник" },
        { kind: "includes", pattern: "штани сатин", result: "Штани з сатину" },
        { kind: "includes", pattern: "штани льон", result: "Штани з льону" },
        { kind: "includes", pattern: "сорочка тепла картата", result: "Сорочка картата" },
        { kind: "includes", pattern: "трикотажна спідниця", result: "Спідниця з трикотажу" },
        { kind: "includes", pattern: "трикотажна безрукавка", result: "Безрукавка з трикотажу" },
        { kind: "includes", pattern: "трикотажні джогери", result: "Джогери з трикотажу" },
        { kind: "includes", pattern: "шапка", result: "Шапка" },
        { kind: "includes", pattern: "труси рюши", result: "Труси з рюшами" },
        { kind: "includes", pattern: "шорти з мереживом", result: "Шорти з рюшами" },
        { kind: "includes", pattern: "футболка рубчик з віризом", result: "Футболка рубчик з вирізом" },
        { kind: "includes", pattern: "сукня з льону на одно плече", result: "Сукня з льону" },
        { kind: "exactList", patterns: ["майка", "майка з кантом"], result: "Майка" },
        {
            kind: "any",
            clauses: [
                { kind: "exact", value: "карго" },
                { kind: "exact", value: "карго з кишенями" },
            ],
            result: "Карго",
        },
        { kind: "exactList", patterns: ["штани з еко-шкіри з принтом"], result: "Брюки з екошкіри" },
        { kind: "exactList", patterns: ["джогери з флісу"], result: "Джогери Фліс" },
        { kind: "exactList", patterns: ["піджак із вовни"], result: "Піджак з вовни" },
        { kind: "exactList", patterns: ["лонгслів"], result: "Лонгслів Оверсайз" },
        { kind: "exactList", patterns: ["пальто"], result: "Пальто стандартного крою" },
        {
            kind: "any",
            clauses: [
                { kind: "exact", value: "худі фліс" },
                { kind: "includes", pattern: "худі чоловічі фліс" },
            ],
            result: "Худі Фліс",
        },
        {
            kind: "exactList",
            patterns: ["топ", "топ new", "топ new з чашечками", "труси new", "труси", "топ з чашечками"],
            result: "Топ чи Труси окремо",
        },
        {
            kind: "exactList",
            patterns: ["труси мустанг", "труси кенді", "труси sex&candy"],
            result: "Труси нові",
        },
        { kind: "exactList", patterns: ["майстерка"], result: "Майстерка" },
        /** Усі інші футболки (друк, літеринг тощо) — після точніших правил вище. */
        { kind: "includes", pattern: "футболка", result: "Футболка з друком" },
    ],
};

export function cloneDefaultProductNameNormalizeConfig() {
    return JSON.parse(JSON.stringify(DEFAULT_PRODUCT_NAME_NORMALIZE_CONFIG));
}
